import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useAuthStore } from '../store/useAuthStore';
import { fetchProfile } from '../lib/api';
import { LoadingState, ErrorState } from '../components/StateViews';
import { ChipIcon } from '../components/ChipIcon';

export function ProfileScreen({ onBack }: { onBack: () => void }) {
  const { token, profile, setProfile } = useAuthStore();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;
    fetchProfile(token)
      .then((p: any) => setProfile(p))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) return <LoadingState label="Загружаю профиль…" />;
  if (error) return <ErrorState message={error} />;
  if (!profile) return null;

  return (
    <div className="min-h-screen px-4 pt-4 pb-10">
      <button onClick={onBack} className="text-white/50 text-sm mb-4">← Назад в лобби</button>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className="flex flex-col items-center gap-3 py-6"
      >
        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-emerald-500 to-felt-800 border-2 border-gold-500/40 flex items-center justify-center text-3xl font-display font-bold text-gold-400">
          {profile.avatarUrl ? (
            <img src={profile.avatarUrl} className="w-full h-full rounded-full object-cover" />
          ) : (
            profile.username.slice(0, 1).toUpperCase()
          )}
        </div>
        <div className="text-white font-display font-bold text-xl">{profile.username}</div>
        <div className="flex items-center gap-2 text-gold-400 text-2xl font-bold tabular-nums">
          <ChipIcon size={22} />
          {profile.chips.toLocaleString('ru-RU')}
        </div>
        <div className="text-white/40 text-xs">фишек в банке</div>
      </motion.div>

      <div className="grid grid-cols-3 gap-2 mt-4">
        <StatCard label="Раздач сыграно" value={profile.handsPlayed} />
        <StatCard label="Выиграно" value={profile.handsWon} />
        <StatCard
          label="Винрейт"
          value={`${profile.winrateBB100 >= 0 ? '+' : ''}${profile.winrateBB100.toFixed(1)}`}
          suffix="bb/100"
        />
      </div>
    </div>
  );
}

function StatCard({ label, value, suffix }: { label: string; value: string | number; suffix?: string }) {
  return (
    <div className="bg-ink-800/70 rounded-xl p-3 border border-white/5 text-center">
      <div className="text-gold-400 font-bold text-lg tabular-nums">{value}</div>
      {suffix && <div className="text-white/30 text-[10px]">{suffix}</div>}
      <div className="text-white/50 text-[11px] mt-1">{label}</div>
    </div>
  );
}
